import {SliderWithUnit} from './SliderWithUnit';

import {withMeta} from '@packages/systems/wfdl';
import {TNumber} from '@packages/systems/wfdl-ast';
import {
  RESULTS_LENGTH_MIN,
  RESULTS_LENGTH_MAX,
} from '@packages/systems/core/constants/SiteSearch';

const value = {
  min: RESULTS_LENGTH_MIN,
  max: RESULTS_LENGTH_MAX,
  step: 1,
} as const;

export const SliderSearchResultsLength = SliderWithUnit({
  min: value.min,
  max: value.max,
  step: value.step,
  inputType: withMeta({value}, TNumber),
});
